(function () {
  if (window.__eolRoutineCardsBoundV2) return;
  window.__eolRoutineCardsBoundV2 = true;

  var ROUTINE_HEADING = 'Create Your Custom Routine in 5 Easy Steps';
  var MOST_LOVED_HEADING = 'Browse Our Most-Loved Products';
  var FOUNDATION_HEADING = 'Finally: Skin-Safe Formulas Designed for Complex Concerns';
  var FOUNDATION_IMAGE = 'https://cdn.shopify.com/s/files/1/1431/4566/files/11988534372.jpg?v=1788489461';
  var MISSION_HEADING = 'Our Mission? Clear, Radiant Skin Without Trade-Offs';
  var MISSION_IMAGE = 'https://cdn.shopify.com/s/files/1/1431/4566/files/leah-founder-2026.jpg?v=1788492287';
  var LABEL_TEXT = 'Add to Cart';
  var productCache = {};

  function injectStyles() {
    if (document.getElementById('eol-routine-commerce-styles')) return;
    var style = document.createElement('style');
    style.id = 'eol-routine-commerce-styles';
    style.textContent = [
      '.eol-routine-commerce{display:flex;flex-direction:column;gap:10px;margin-top:8px;width:100%;}',
      '.eol-most-loved-image-link{display:block;width:100%;cursor:pointer;}',
      '.eol-most-loved-image-link:focus-visible{outline:2px solid #4B5E77;outline-offset:3px;}',
      '#bndlr-discount-message,.bndlr-go-to-checkout{display:none!important;}',
      '.eol-routine-rating{min-height:22px;color:#383D4B;}',
      '.eol-routine-rating .stamped-badge{font-size:15px!important;line-height:1.35;}',
      '.eol-routine-rating .stamped-fa-star{color:#383D4B!important;}',
      '.eol-routine-rating .stamped-badge-caption{margin-left:6px;color:#383D4B!important;}',
      '.eol-routine-sizes{display:flex;flex-wrap:wrap;gap:7px;border:0;padding:0;margin:0;min-width:0;}',
      '.eol-routine-sizes legend{width:100%;padding:0;margin:0 0 2px;color:#383D4B;font-size:13px;font-weight:600;}',
      '.eol-routine-sizes--placeholder{height:52px;visibility:hidden;pointer-events:none;}',
      '.eol-routine-size{position:relative;cursor:pointer;}',
      '.eol-routine-size input{position:absolute;opacity:0;pointer-events:none;}',
      '.eol-routine-size span{display:block;min-width:54px;padding:8px 10px;border:1px solid #4B5E77;border-radius:2px;background:#F4F1F0;color:#383D4B;font-size:13px;line-height:1;text-align:center;}',
      '.eol-routine-size input:checked+span{background:#4B5E77;color:#F4F1F0;}',
      '.eol-routine-size input:focus-visible+span{outline:2px solid #CCA2B0;outline-offset:2px;}',
      '.eol-routine-size.is-sold-out{cursor:not-allowed;opacity:.45;}',
      '.eol-routine-size.is-sold-out span{text-decoration:line-through;}',
      '.eol-routine-add,.eol-collection-add{display:block;width:100%;min-height:48px;padding:13px 18px;border:1px solid #4B5E77;border-radius:2px;background:#4B5E77;color:#F4F1F0;font:inherit;font-weight:600;cursor:pointer;}',
      '.eol-routine-add{letter-spacing:.12em;text-transform:uppercase;}',
      '.eol-routine-add:hover,.eol-collection-add:hover{background:#383D4B;border-color:#383D4B;}',
      '.eol-routine-add:focus-visible,.eol-collection-add:focus-visible{outline:3px solid #CCA2B0;outline-offset:2px;}',
      '.eol-routine-add:disabled,.eol-collection-add:disabled{cursor:wait;opacity:.7;}',
      '#main-collection-product-grid{align-items:stretch;}',
      '.eol-collection-tile{display:flex!important;flex-direction:column;}',
      '.eol-collection-commerce{display:flex;flex-direction:column;gap:10px;width:100%;margin-top:auto;}',
      '.eol-collection-card{display:flex!important;flex:1 1 auto;flex-direction:column;align-self:stretch;height:auto!important;}',
      '.eol-collection-card .quick-add-to-cart,.eol-collection-card .js-quick-add{display:flex;flex-direction:column;margin-top:auto;}',
      '.eol-collection-commerce .eol-routine-sizes{margin-bottom:2px;}',
      '.eol-collection-commerce .eol-routine-sizes legend{font-size:14px;}',
      '.eol-collection-add{font-size:16px;font-weight:400;}',
      '.eol-bis-slot{width:100%;}',
      '.eol-bis-button{display:flex!important;align-items:center;justify-content:center;width:100%!important;min-height:48px!important;padding:13px 18px!important;border:1px solid #4B5E77!important;border-radius:2px!important;background:#4B5E77!important;color:#F4F1F0!important;font-family:"DM Sans",sans-serif!important;font-size:16px!important;font-weight:600!important;line-height:1.2!important;text-align:center!important;text-decoration:none!important;cursor:pointer!important;}',
      '.eol-bis-button:hover{background:#383D4B!important;border-color:#383D4B!important;}',
      '.eol-bis-button:focus-visible{outline:3px solid #CCA2B0!important;outline-offset:2px!important;}',
      '.eol-all-skin-image{width:100%!important;height:100%!important;object-fit:cover!important;object-position:center center!important;}',
      '.eol-mission-image{width:100%!important;height:100%!important;object-fit:cover!important;object-position:center 18%!important;}',
      '@media(max-width:640px){.eol-routine-commerce{gap:9px}.eol-routine-size span{min-width:50px;padding:9px 8px}.eol-routine-add{min-height:46px;font-size:13px;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function getCartUrls() {
    var urls = window.EOL_CART_URLS || {};
    return { add: urls.add || '/cart/add.js', cart: urls.cart || '/cart' };
  }

  function getRoutineRoot() {
    var headings = document.querySelectorAll('h1, h2, h3, [role="heading"]');
    for (var i = 0; i < headings.length; i += 1) {
      if ((headings[i].textContent || '').trim() !== ROUTINE_HEADING) continue;
      var node = headings[i];
      while (node && node !== document.body) {
        if (
          node.querySelectorAll('[data-replo-product-handle]').length >= 20 &&
          node.querySelectorAll('[role="tab"]').length >= 5
        ) {
          if (!node.id) node.id = 'build-your-routine';
          return node;
        }
        node = node.parentElement;
      }
    }
    return null;
  }

  function getMostLovedRoot() {
    var headings = document.querySelectorAll('h1, h2, h3, [role="heading"]');
    for (var i = 0; i < headings.length; i += 1) {
      if ((headings[i].textContent || '').trim() !== MOST_LOVED_HEADING) continue;
      var node = headings[i];
      while (node && node !== document.body) {
        var products = node.querySelectorAll('[data-replo-product-handle]');
        if (products.length >= 4 && products.length <= 8) {
          if (!node.id) node.id = 'browse-most-loved';
          return node;
        }
        node = node.parentElement;
      }
    }
    return null;
  }

  function enhanceFoundationStory() {
    var headings = document.querySelectorAll('h1, h2, h3, [role="heading"]');
    var heading = null;
    for (var i = 0; i < headings.length; i += 1) {
      var headingText = (headings[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (headingText === FOUNDATION_HEADING || headingText === 'Acne-safe by design. Made for every skin story') {
        heading = headings[i];
        break;
      }
    }
    if (!heading) return false;
    if (heading.getAttribute('data-eol-foundation-ready') === 'true') return true;

    heading.textContent = 'Acne-safe by design. Made for every skin story';
    heading.setAttribute('data-eol-foundation-ready', 'true');
    heading.classList.add('eol-all-skin-heading');

    var replacements = [
      {
        from: 'Other targeted treatments attack a single concern and leave you to deal with the flaky, irritated, or pore-clogging fallout. At EOL, we treat your skin as a balanced ecosystem so it can heal from within.',
        to: 'I created EOL from my own struggle with acne and melasma, then shaped it through nearly 22 years of hands-on work as an aesthetician. Acne-safe is our foundation—not our limitation. Every formula is designed to support skin as it changes, from breakouts and pigmentation to dryness, sensitivity, redness and visible aging.'
      },
      { from: 'Aesthetician-made, dermatologist-tested', to: 'Aesthetician-created, dermatologist-tested' },
      { from: 'Acne-safe & pore-safe', to: 'Acne-safe at the foundation—not acne-only' },
      { from: 'Formulated for holistic skin health', to: 'Thoughtful care for every skin type and stage' }
    ];

    document.querySelectorAll('p, div, span').forEach(function (element) {
      var normalized = (element.textContent || '').replace(/\s+/g, ' ').trim();
      replacements.forEach(function (replacement) {
        if (normalized === replacement.from) element.textContent = replacement.to;
      });
    });

    var image = document.querySelector('img[alt^="Woman smiling and spraying a bottle"], img.eol-all-skin-image');
    if (image) {
      image.src = FOUNDATION_IMAGE;
      image.srcset = FOUNDATION_IMAGE;
      image.setAttribute('data-src', FOUNDATION_IMAGE);
      image.setAttribute('data-srcset', FOUNDATION_IMAGE);
      image.alt = 'Leah Corrin, founder of EOL Medical Skincare, holding an EOL skincare box';
      image.classList.add('eol-all-skin-image');
      var picture = image.closest('picture');
      if (picture) {
        picture.querySelectorAll('source').forEach(function (source) {
          source.srcset = FOUNDATION_IMAGE;
        });
      }
    }
    return true;
  }

  function enhanceFounderMissionStory() {
    var headings = document.querySelectorAll('h1, h2, h3, [role="heading"]');
    var heading = null;
    for (var i = 0; i < headings.length; i += 1) {
      var headingText = (headings[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (
        headingText === MISSION_HEADING ||
        headingText === 'The skincare I needed became the skincare I created'
      ) {
        heading = headings[i];
        break;
      }
    }
    if (!heading) return false;
    var section = heading;
    while (section && section !== document.body) {
      var sectionText = (section.textContent || '').replace(/\s+/g, ' ').trim();
      if (
        (
          sectionText.indexOf('Ready to build your own no-compromises skin routine?') !== -1 ||
          sectionText.indexOf('Ready to discover the routine shaped by nearly 22 years in the treatment room?') !== -1
        ) &&
        section.querySelector('img[alt^="Woman with long dark hair holding a mug"], img.eol-mission-image')
      ) break;
      section = section.parentElement;
    }
    if (!section || section === document.body) return false;

    heading.textContent = 'The skincare I needed became the skincare I created';
    heading.setAttribute('data-eol-mission-ready', 'true');

    var replacements = [
      {
        from: 'A wave of confidence.',
        to: 'Born from real skin. Built through experience.'
      },
      {
        from: 'As an experienced aesthetician and longtime acne sufferer, our founder Leah established the Essence of L Medi Spa to tackle complex skin concerns by focusing on holistic skin health.',
        to: 'My relationship with skin started personally—with acne, melasma, and the frustration of products that solved one concern while creating another. That experience led me to become an aesthetician and open Essence of L Medi Spa.'
      },
      {
        from: '20 years later, and tired of products that helped one issue but worsened others, she worked with dermatologists to develop EOL skincare: targeted, skin-friendly products (that she personally tests for 3 months to ensure results) that balance and perfect skin from the inside out.',
        to: 'For nearly 22 years, I listened to clients, treated complex skin, and learned what skin needs to feel calm, clear, resilient, and supported as it changes. EOL is the result: acne-safe at its foundation, thoughtful enough for every skin story.'
      },
      {
        from: 'Ready to build your own no-compromises skin routine?',
        to: 'Ready to discover the routine shaped by nearly 22 years in the treatment room?'
      },
      {
        from: 'Medi Spa 2025',
        to: 'Medi Spa 2026'
      }
    ];

    section.querySelectorAll('p, div, span').forEach(function (element) {
      var normalized = (element.textContent || '').replace(/\s+/g, ' ').trim();
      replacements.forEach(function (replacement) {
        if (normalized === replacement.from) element.textContent = replacement.to;
      });
    });

    var image = section.querySelector('img[alt^="Woman with long dark hair holding a mug"], img.eol-mission-image');
    if (image) {
      image.src = MISSION_IMAGE;
      image.srcset = MISSION_IMAGE;
      image.setAttribute('data-src', MISSION_IMAGE);
      image.setAttribute('data-srcset', MISSION_IMAGE);
      image.alt = 'Leah Corrin, founder of EOL Medical Skincare';
      image.classList.add('eol-mission-image');
      var picture = image.closest('picture');
      if (picture) {
        picture.querySelectorAll('source').forEach(function (source) {
          source.srcset = MISSION_IMAGE;
        });
      }
    }
    return true;
  }

  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Product information could not be loaded.');
        return response.json();
      });
    }
    return productCache[handle];
  }

  function money(cents) {
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD'
    }).format(cents / 100);
  }

  function updatePrice(container, variant) {
    var selectedPrice = container.querySelector('.eol-selected-price');
    if (selectedPrice) {
      selectedPrice.textContent = money(variant.price);
      return;
    }
    var price = container.querySelector('[data-replo-price] .money, [data-replo-price]');
    if (price) {
      price.textContent = money(variant.price);
      return;
    }
    container.querySelectorAll(
      '.price__regular .price-item--regular, .price__sale .price-item--sale'
    ).forEach(function (priceItem) {
      priceItem.textContent = money(variant.price);
    });
  }

  function hideOldCommerce(container) {
    container.querySelectorAll('.eol-replo-review-badge, .eol-routine-commerce').forEach(function (el) {
      el.remove();
    });
    container.querySelectorAll('a, button, [role="button"]').forEach(function (el) {
      var text = (el.textContent || '').trim().toLowerCase();
      if (text === 'shop now' || text === 'add to cart') {
        el.setAttribute('data-eol-original-commerce', 'true');
        el.style.display = 'none';
      }
    });
    container.querySelectorAll('*').forEach(function (el) {
      var text = (el.textContent || '').trim();
      if (text === '(Reviews)' || text === '()') el.style.display = 'none';
    });
  }

  function addStampedRating(wrapper, product) {
    var row = document.createElement('div');
    row.className = 'eol-routine-rating';
    var badge = document.createElement('span');
    badge.className = 'stamped-product-reviews-badge stamped-main-badge';
    badge.setAttribute('data-id', product.id);
    badge.setAttribute('data-product-sku', product.handle);
    badge.setAttribute('data-product-title', product.title);
    badge.setAttribute('data-product-type', product.type || '');
    badge.style.display = 'block';
    row.appendChild(badge);
    wrapper.appendChild(row);
  }

  function addVariantSelector(wrapper, container, product, state) {
    var available = product.variants.filter(function (variant) { return variant.available; });
    if (product.variants.length <= 1) {
      state.variant = available[0] || product.variants[0];
      var placeholder = document.createElement('div');
      placeholder.className = 'eol-routine-sizes eol-routine-sizes--placeholder';
      placeholder.setAttribute('aria-hidden', 'true');
      wrapper.appendChild(placeholder);
      return;
    }

    var group = document.createElement('fieldset');
    group.className = 'eol-routine-sizes';
    var legend = document.createElement('legend');
    legend.textContent = 'Choose a size';
    group.appendChild(legend);

    product.variants.forEach(function (variant, index) {
      var label = document.createElement('label');
      label.className = 'eol-routine-size' + (variant.available ? '' : ' is-sold-out');
      var input = document.createElement('input');
      input.type = 'radio';
      input.name = 'eol-size-' + product.id + '-' + (
        container.getAttribute('data-rid') || container.getAttribute('data-product-id') || 'card'
      );
      input.value = variant.id;
      input.disabled = !variant.available;
      input.checked = variant.available && !state.variant;
      if (input.checked) state.variant = variant;
      input.addEventListener('change', function () {
        state.variant = variant;
        updatePrice(container, variant);
      });
      var span = document.createElement('span');
      span.textContent = variant.public_title || variant.title;
      label.appendChild(input);
      label.appendChild(span);
      group.appendChild(label);
    });
    if (wrapper.classList.contains('eol-collection-commerce')) {
      var listingPrice = container.querySelector('.price--listing');
      if (listingPrice) listingPrice.innerHTML = '<span class="eol-selected-price"></span>';
    }
    wrapper.appendChild(group);
    if (state.variant) updatePrice(container, state.variant);
  }

  function refreshCartContent() {
    var urls = getCartUrls();
    var ajaxCartUrl = urls.cart.replace(/\/+$/, '') + '?view=ajax';
    return fetch(ajaxCartUrl, { credentials: 'same-origin' })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('template[data-html="content"]');
        if (content) {
          document.querySelectorAll('.js-ajax-cart-content').forEach(function (el) {
            el.innerHTML = content.innerHTML;
          });
        }
        var options = doc.querySelector('template[data-options]');
        if (options) {
          try {
            var data = JSON.parse(options.textContent);
            document.querySelectorAll('.js-cart-count').forEach(function (el) {
              el.textContent = data.item_count;
            });
          } catch (error) {}
        }
      });
  }

  function addButton(wrapper, state, className) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = className || 'eol-routine-add';
    button.textContent = LABEL_TEXT;
    if (!state.variant || !state.variant.available) {
      button.disabled = true;
      button.textContent = 'Sold Out';
    }
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (!state.variant || !state.variant.available || button.disabled) return;
      button.disabled = true;
      button.textContent = 'Adding…';
      fetch(getCartUrls().add, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: state.variant.id, quantity: 1 })
      })
        .then(function (response) {
          if (response.ok) return response.json();
          return response.json().then(function (error) {
            throw new Error((error && error.description) || 'Could not add that item to your cart.');
          });
        })
        .then(refreshCartContent)
        .then(function () {
          button.textContent = 'Added ✓';
          var trigger = document.querySelector('.js-mini-cart-trigger');
          if (trigger) trigger.click();
          setTimeout(function () {
            button.disabled = false;
            button.textContent = LABEL_TEXT;
          }, 1500);
        })
        .catch(function (error) {
          button.disabled = false;
          button.textContent = LABEL_TEXT;
          window.alert(error.message || 'Sorry, something went wrong adding that item.');
        });
    });
    wrapper.appendChild(button);
  }

  function linkMostLovedImage(container, product, handle) {
    if (container.getAttribute('data-eol-most-loved-image-linked') === 'true') return;
    var picture = container.querySelector('picture');
    if (!picture || picture.closest('a[href*="/products/"]')) return;
    var originalLink = container.querySelector('a[href*="/products/"]');
    var link = document.createElement('a');
    link.className = 'eol-most-loved-image-link';
    link.href = originalLink ? originalLink.getAttribute('href') : '/products/' + encodeURIComponent(handle);
    link.setAttribute('aria-label', 'View ' + (product.title || handle.replace(/-/g, ' ')));
    ['click', 'pointerdown', 'mousedown', 'touchstart'].forEach(function (eventName) {
      link.addEventListener(eventName, function (event) { event.stopPropagation(); });
    });
    picture.parentNode.insertBefore(link, picture);
    link.appendChild(picture);
    container.setAttribute('data-eol-most-loved-image-linked', 'true');
  }

  function enhanceMostLovedContainer(container) {
    enhanceContainer(container);
    var handle = container.getAttribute('data-replo-product-handle');
    if (!handle) return;
    getProduct(handle).then(function (product) {
      linkMostLovedImage(container, product, handle);
    }).catch(function () {});
  }

  function enhanceContainer(container) {
    if (container.getAttribute('data-eol-routine-ready') === 'true') return;
    var handle = container.getAttribute('data-replo-product-handle');
    if (!handle) return;
    container.setAttribute('data-eol-routine-ready', 'loading');
    getProduct(handle).then(function (product) {
      hideOldCommerce(container);
      var wrapper = document.createElement('div');
      wrapper.className = 'eol-routine-commerce';
      ['click', 'pointerdown', 'mousedown', 'touchstart'].forEach(function (eventName) {
        wrapper.addEventListener(eventName, function (event) { event.stopPropagation(); });
      });
      var state = { variant: null };
      addStampedRating(wrapper, product);
      addVariantSelector(wrapper, container, product, state);
      addButton(wrapper, state, 'eol-routine-add');
      container.appendChild(wrapper);
      container.setAttribute('data-eol-routine-ready', 'true');
    }).catch(function () {
      container.removeAttribute('data-eol-routine-ready');
    });
  }

  function enhanceRoutine() {
    var root = getRoutineRoot();
    if (!root) return false;
    if (window.location.hash === '#build-your-routine' && !window.__eolRoutineJumped) {
      window.__eolRoutineJumped = true;
      window.requestAnimationFrame(function () {
        root.scrollIntoView({ behavior: 'auto', block: 'start' });
      });
    }
    root.querySelectorAll('[data-replo-product-handle]').forEach(enhanceContainer);
    setTimeout(function () {
      if (window.StampedFn && typeof window.StampedFn.reloadUGC === 'function') {
        window.StampedFn.reloadUGC();
      }
    }, 500);
    return true;
  }

  function enhanceMostLoved() {
    var root = getMostLovedRoot();
    if (!root) return false;
    root.querySelectorAll('[data-replo-product-handle]').forEach(enhanceMostLovedContainer);
    setTimeout(function () {
      if (window.StampedFn && typeof window.StampedFn.reloadUGC === 'function') {
        window.StampedFn.reloadUGC();
      }
    }, 500);
    return true;
  }

  function collectionHandleFromCard(card) {
    var productLink = card.querySelector('a[href*="/products/"]');
    if (!productLink) return '';
    var match = productLink.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function enhanceCollectionCard(card) {
    if (card.getAttribute('data-eol-collection-ready')) return;
    var originalAction = Array.prototype.slice.call(card.querySelectorAll('a, button')).find(function (element) {
      var text = (element.textContent || '').trim().toLowerCase();
      return text === 'add to cart' || text === 'select option';
    });
    var quickAdd = card.querySelector('.quick-add-to-cart, .js-quick-add') || (
      originalAction && (originalAction.closest('.quick-add-to-cart, .js-quick-add') || originalAction.parentElement)
    );
    var handle = collectionHandleFromCard(card);
    if (!quickAdd || !handle) return;
    var tile = card.closest('.product-index');
    if (tile) tile.classList.add('eol-collection-tile');
    card.classList.add('eol-collection-card');
    card.setAttribute('data-eol-collection-ready', 'loading');
    getProduct(handle).then(function (product) {
      var wrapper = document.createElement('div');
      wrapper.className = 'eol-collection-commerce';
      var state = { variant: null };
      addVariantSelector(wrapper, card, product, state);
      addButton(wrapper, state, 'eol-collection-add');
      quickAdd.innerHTML = '';
      quickAdd.appendChild(wrapper);
      card.setAttribute('data-eol-collection-ready', 'true');
    }).catch(function () {
      card.removeAttribute('data-eol-collection-ready');
    });
  }

  function enhanceCollection() {
    if (!/^\/collections\/[^/]+\/?$/i.test(window.location.pathname)) return false;
    var grid = document.querySelector('#main-collection-product-grid');
    if (!grid) return false;
    var cards = [];
    grid.querySelectorAll('.quick-add-to-cart, .js-quick-add').forEach(function (quickAdd) {
      var card = quickAdd.closest('.product-info') || quickAdd.parentElement;
      if (card && cards.indexOf(card) === -1) cards.push(card);
    });
    cards.forEach(enhanceCollectionCard);
    return true;
  }

  function findOutOfStockButton() {
    var candidates = document.querySelectorAll('main button, main a');
    for (var i = 0; i < candidates.length; i += 1) {
      var text = (candidates[i].textContent || '').trim().toLowerCase();
      if (text === 'out of stock' || text === 'sold out') return candidates[i];
    }
    return null;
  }

  function enhanceBackInStock() {
    if (!/\/products\/[^/]+\/?$/i.test(window.location.pathname)) return false;
    if (document.querySelector('.eol-bis-slot')) return true;
    var soldOutButton = findOutOfStockButton();
    if (!soldOutButton) return false;

    var slot = document.createElement('div');
    slot.className = 'eol-bis-slot';
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'eol-bis-button';
    trigger.textContent = 'Notify me';
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      if (window.klaviyo && typeof window.klaviyo.openForm === 'function') {
        window.klaviyo.openForm('VsCthe');
        return;
      }
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'VsCthe']);
    });
    slot.appendChild(trigger);

    soldOutButton.style.display = 'none';
    soldOutButton.insertAdjacentElement('afterend', slot);
    return true;
  }

  function enhanceAll() {
    enhanceFoundationStory();
    enhanceFounderMissionStory();
    enhanceMostLoved();
    enhanceRoutine();
    enhanceCollection();
    enhanceBackInStock();
  }

  function start() {
    injectStyles();
    enhanceAll();
    [300, 800, 1500, 3000].forEach(function (delay) { setTimeout(enhanceAll, delay); });

    if (/\/products\/[^/]+\/?$/i.test(window.location.pathname) && window.MutationObserver) {
      var backInStockTimer = null;
      var backInStockObserver = new MutationObserver(function () {
        window.clearTimeout(backInStockTimer);
        backInStockTimer = window.setTimeout(enhanceBackInStock, 120);
      });
      backInStockObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
